import { useQuery } from '@tanstack/react-query'
import { useDI } from '@/di/DIContext'
import type { AgentId } from '@/domain/shared/Brand'

export function useTeamMembers() {
  const { affiliateService, sessionService } = useDI()
  const agentId = sessionService.getAgentId()

  const { data: teamSummary, isLoading } = useQuery({
    queryKey: ['teamSummary', agentId],
    queryFn: () => affiliateService.getTeamSummary(agentId as AgentId),
    enabled: !!agentId,
    gcTime: 0,
    retry: false,
  })

  const teamStats = teamSummary
    ? {
        totalMembers: teamSummary.totalCount.consumers_count,
        recentMembers: teamSummary.recentMembers,
      }
    : null

  return {
    teamStats,
    isTeamLoading: isLoading,
  }
}
